module.exports = __webpack_public_path__ + "static/media/hero-snap-three.fe3258a0.jpg";